<div class="video-image-container" [matTooltip]="toolTipText" matTooltipClass="error-tip">
    <img *ngIf="imageSource && !errored " [src]="imageSource"  (error)="onError()" /> 
    <mat-icon *ngIf="errored">broken_image</mat-icon>
</div>